import { ITopicRuleFormInput } from "../../Pages/TopicRule/TopicRule.model";
import { buildApiUrl } from "../../config/api";
import axiosInstance from "../axios/axiosInstance";

const API = buildApiUrl("/interviewQuestionApp/topic-rules/");

export const topicRuleService = {
  async getAll() {
    return axiosInstance.get(API);
  },
  async create(payload: ITopicRuleFormInput) {
    return axiosInstance.post(API, payload);
  },
  async update(id: number, data: ITopicRuleFormInput) {
    try {
      const res = await axiosInstance.put(`${API}${id}/`, data);
      return { success: true, data: res.data };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },
  async remove(id: number) {
    try {
      const res = await axiosInstance.delete(`${API}${id}/`);
      return { success: true, data: res };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },
};
